import React from "react";
import { useTranslation } from "react-i18next";

export type EmptyStateProps = {
  icon?: string;
  title: string;
  description?: string;
  className?: string;
};

/**
 * Pure presentational component for empty state
 */
const EmptyState = ({
  icon = "📊",
  title,
  description = "Start tracking your moods to see trends and insights here!",
  className = "empty-state-container",
}: EmptyStateProps) => {
  const { t } = useTranslation();

  return (
    <div className={className}>
      <div className="empty-state-icon">{icon}</div>
      <h3 className="empty-state-title">
        {title || t("homepage.noMoodDataAvailable")}
      </h3>
      <p className="empty-state-text">{description}</p>
    </div>
  );
};

export default EmptyState;
